'use es6';

import Loadable from 'UIComponents/decorators/Loadable';
export const AsyncPricingBreakdownModal = Loadable({
  loader: () => import(
  /* webpackChunkName: "pricing-breakdown-modal" */
  './PricingBreakdownModal'),
  LoadingComponent: () => null
});